import { motion, AnimatePresence } from 'framer-motion'
import { CaretLeft } from 'phosphor-react'
import { type FormEvent, useRef, useState, useEffect } from 'react'
import { createPortal } from 'react-dom'

import { Button } from '../../../../components/Button'
import { Checkbox } from '../../../../components/FormElements/Checkbox'
import { type Column } from '../../../../components/Table'
import { Medias } from '../../../../enumns/medias'
import { useMediaQuery } from '../../../../hooks/useMediaQuery'
import { useOnClickOutside } from '../../../../hooks/useOnClickOutside'

type ConfigureTableColumnsMenuProps = {
  isOpen: boolean
  columns: Column[]
  onClose: () => void
  onConfigureColumns: (columns: Column[]) => void
}

export const MeetingFilter = ({
  isOpen,
  columns,
  onClose,
  onConfigureColumns,
}: ConfigureTableColumnsMenuProps) => {
  const [columnsToManipulate, setColumnsToManipulate] = useState(columns)
  const [checkeds, setCheckeds] = useState(0)

  const isTabletSize = useMediaQuery(`(min-width: ${Medias.MD}px)`)
  const tableColumnsMenuEl = useRef(null)

  useOnClickOutside(tableColumnsMenuEl, onClose)

  useEffect(() => {
    let total = 0
    columnsToManipulate.forEach((column) => {
      if (column.isVisible === true) {
        total++
      }
    })
    setCheckeds(total)
  }, [])

  const controlCheck = (element: any) => {
    if (element.target.checked) {
      if (checkeds === 3) {
        element.target.checked = false
      } else {
        if (checkeds < 3) {
          setCheckeds(checkeds + 1)
        }
      }
    } else {
      setCheckeds(checkeds - 1)
    }
  }

  const handleApplyChangesToColumns = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    const formValues = Array.from<HTMLInputElement>(
      (event?.target as any).columns
    )

    const updatedColumns = columns.map((column) => {
      const formValue = formValues.find(({ id }) => id === column.field)

      if (formValue) {
        return {
          ...column,
          isVisible: formValue.checked,
        }
      }

      return column
    })

    onConfigureColumns(updatedColumns)
    setColumnsToManipulate(updatedColumns)
    onClose()
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          {isTabletSize ? (
            <div
              ref={tableColumnsMenuEl}
              className="shadow-lg absolute right-0 z-50 w-64 p-4 bg-white rounded-lg flex flex-col gap-2.5"
            >
              <form onSubmit={handleApplyChangesToColumns}>
                <fieldset className="pb-4 space-y-4 overflow-y-scroll max-h-64 scrollbar">
                  {columnsToManipulate.map(
                    ({ field, headerName, isVisible = true }) => (
                      <Checkbox
                        name="columns"
                        id={field}
                        key={field}
                        label={headerName}
                        defaultChecked={isVisible}
                        onChangeCapture={(element) => {
                          controlCheck(element)
                        }}
                      />
                    )
                  )}
                </fieldset>

                <div className="mt-2 before:w-[calc(100%-12px)] relative before:absolute before:top-[-2rem] before:left-0 before:h-8 before:bg-gradient-to-t from-white to-transparent">
                  <Button
                    size="small"
                    fullWidth
                    type="submit"
                    className="mx-auto w-44"
                  >
                    Aplicar
                  </Button>
                </div>
              </form>
            </div>
          ) : (
            <>
              {createPortal(
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  className="fixed top-0 bottom-0 left-0 right-0 z-50 p-6 overflow-y-auto bg-white scrollbar"
                >
                  <button
                    aria-label="Voltar"
                    className="mb-8"
                    onClick={() => onClose()}
                  >
                    <CaretLeft size={24} className="text-grey-700" />
                  </button>

                  <>
                    <strong className="block mb-8 text-grey-900">
                      Filtrar reuniões
                    </strong>

                    <form
                      onSubmit={handleApplyChangesToColumns}
                      className="flex flex-col flex-wrap h-[calc(100vh_-_196px)] justify-between"
                    >
                      <fieldset className="mb-6 space-y-4">
                        {columnsToManipulate.map(
                          ({ field, headerName, isVisible = true }) => (
                            <Checkbox
                              name="columns"
                              id={field}
                              key={field}
                              label={headerName}
                              defaultChecked={isVisible}
                            />
                          )
                        )}
                      </fieldset>

                      <Button type="submit" fullWidth>
                        Aplicar
                      </Button>
                    </form>
                  </>
                </motion.div>,
                document.body
              )}
            </>
          )}
        </>
      )}
    </AnimatePresence>
  )
}
